module.exports = __webpack_public_path__ + "static/media/sms.723f841b.png";